/** Retour haptique : Capacitor Haptics en natif, navigator.vibrate en PWA, silencieux sinon. */
const isNative = () => typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.();

async function native(fn) {
  try {
    const { Haptics, ImpactStyle, NotificationType } = await import("@capacitor/haptics");
    await fn(Haptics, ImpactStyle, NotificationType);
    return true;
  } catch { return false; }
}

const vibrate = (pattern) => { try { navigator.vibrate?.(pattern); } catch { /* non supporté */ } };

export const haptic = {
  light: () => isNative() ? native((H, I) => H.impact({ style: I.Light })) : vibrate(8),
  medium: () => isNative() ? native((H, I) => H.impact({ style: I.Medium })) : vibrate(15),
  success: () => isNative() ? native((H, _i, N) => H.notification({ type: N.Success })) : vibrate([10, 40, 20]),
  warning: () => isNative() ? native((H, _i, N) => H.notification({ type: N.Warning })) : vibrate([20, 30, 20]),
};
